import type { FacilityFilterType } from './consultsService';
import { httpRequest } from '../../shared/lib/utils/httpClient';

export interface StatusData {
  label: string;
  value: number;
}

export interface DonutChart {
  statusData: StatusData[];
  acceptData: StatusData[];
}

export interface LineChartData {
  labels: string[];
  data: number[];
}

export interface LineChartType {
  '1W': LineChartData;
  '1M': LineChartData;
  '6M': LineChartData;
  '1Y': LineChartData;
  '5Y': LineChartData;
}

export interface MetricCardData {
  facilityLogo: string | null;
  facilityName: string | null;
  facilityId: number;
  partnerId: number;
  partnerName: string | null;
  totalRequest: number;
  donutChart: DonutChart;
  lineChart: LineChartType | null;
}

export interface MetricsResponse {
  totalRequests: number;
  newRequests: number;
  accepted: number;
  inProgress: number;
  callStarted: number;
  callCompleted: number;
  completed: number;
  canceled: number;
  lastUpdated: string;
  metricCardData: MetricCardData[];
}

export const getMetricsData = async (): Promise<MetricsResponse> => {
  const response = await httpRequest<MetricsResponse>({
    url: `/clinical/metrics`,
    method: 'GET',
  });
  return response;
};

export const getFacilityFilter = async (): Promise<FacilityFilterType> => {
  const response = await httpRequest<FacilityFilterType>({
    url: `clinical/consult/health-system`,
    method: 'GET',
  });
  return response;
};
